module.exports = "/packs/she-hirameki-4045a4bbeed3c5b1167d079fd2d758d9.png";